import React from 'react'
import TableHeader from "./dashboardcomp/nav.js"
import Sidebar from "./dashboardcomp/sidebar.js"
import Table from "../components/dashboardcomp/table.js"
import TableNav from './dashboardcomp/tablenav.js'



export default function Dashboard() {
  return (
    <div className='container' >
      
      
      <TableHeader />
      <Sidebar />
      <TableNav/>
     <Table/>
 
      
    </div>
  )
}
